import React from "react";
import {
  Container,
  Form,
  Label,
  Input,
  FormGroup,
  Col,
  Row,
  Button,
} from "reactstrap";
import { colors } from "../Utils/Colors";
import axios from "axios";
import { serverUrls, clientUrls } from "../Utils/Urls";
import { connect } from "react-redux";
import {
  login,
  loginSuccess,
  loginFailure,
  formInputChange,
} from "../Actions/userFormAction";
import { redirectTo } from "../Utils/RedirectUtil";
import Logo from "../images/PGIMER_logo.png";
import Dr2 from "../images/Dr_Bhadada_1.jpg";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.login = this.login.bind(this);
  }

  onChange = (e) => {
    this.props.formInputChange({ name: e.target.name, value: e.target.value });
  };

  login = (e) => {
    e.preventDefault();
    var payload = {
      username: this.props.username,
      password: this.props.password,
    };
    this.props.login(payload);
  };

  render() {
    return (
      <div>
        <Container>
          <Row>
            <Col style={{ textAlign: "left" }} sm={3}>
              <img style={{ maxWidth: 200 }} src={Logo} alt={"dr"} />
            </Col>
            <Col style={{ textAlign: "left" }} sm={6}>
              <h1 style={{ paddingTop: "12.5%", textAlign: "left" }}>
                Indian Rare MBD Registry
              </h1>
            </Col>
            <Col style={{ textAlign: "left" }} sm={3} />
          </Row>
          <hr style={{background: colors.greenGrey}} />
          <Row>
            <Col style={{ textAlign: "left" }} sm={8}>
              <div style={{ textAlign: "left" }}>
                {/* <h2>Welcome To Indian RMBD registry </h2> */}

                <br />
                <p>
                  Rare MBD are less recognized and due to its rarity, often
                  associated with delayed diagnosis. Metabolic bone disease is
                  the third most common endocrine disorders after diabetes and
                  thyroid diseases. The common metabolic bone diseases (MBD)
                  include osteoporosis, rickets/ osteomalacia, flurosis and
                  primary hyperparathyroidism (PHPT), while the rare MBDs
                  include Paget's disease, tumor induced osteomalacia, fibrous
                  dysplasia, osteogenesis imperfecta and so on.
                </p>
                <br />
                <br />
              </div>
              <Row>
                <Col sm={4} style={{ textAlign: "left" }}>
                  <img style={{ maxWidth: 200 }} src={Dr2} alt={"dr"} />
                </Col>
                <Col style={{ textAlign: "left" }} sm={8}>
                  <h4 style={{ color: colors.grey }}>
                    Dr SANJAY KUMAR BHADADA
                  </h4>
                  <strong>
                    MD General Medicine, DM (Endocrinology), FRCPI, FAMS
                  </strong>
                  <br />
                  <b style={{ color: colors.grey }}>Professor</b>
                  <br />
                  <b style={{ color: colors.grey }}>
                    Department of Endocrinology
                  </b>
                  <br />
                  <b style={{ color: colors.grey }}>
                    Postgraduate Institute of Medical Education and Research
                    (PGIMER), Chandigarh
                  </b>
                </Col>
              </Row>
              <br />
              <br />
              <br />
              <h3>About Us</h3>
              <hr />
              <p>
                The purpose of Indian{" "}
                <strong>Rare Metabolic Bone Disorders</strong> (RMBD) registry
                is to help medical personals and researchers in better
                understanding of the disease and apply them into better patient
                care. More specifically the objectives of this registry program
                are as follows:
              </p>
              <ul>
                <li>
                  Maintain clinical, biochemical, haematological and
                  radiological profile of patients diagnosed with RMBD
                </li>
                <li>
                  Changes in symptoms, biochemical parameters and complications
                  over the time after diagnosis and treatment.
                </li>
                <li>
                  To evaluate current status of the Metabolic Bone Disorders,
                  complications and curative practices applied by clinicians in
                  disease subjects in India.
                </li>
                <li>
                  To access disease incidence in India and mortality rates of
                  patients with RMBD
                </li>
                <li>
                  Conduct and promote research on Metabolic Bone Disorders using
                  clinical, biochemical and basic science approaches.
                </li>
              </ul>
              <p>
                The Indian RMBD registry will act as data source of patient
                information and help in continuing development of patient care
                in RMBD. Registry program will help endocrinologists,
                nephrologists, pathologists, radiologists and orthopaedic
                surgeons in understanding the disease in a better way and apply
                it in management of the disease.
              </p>
              <br />
              <h3>Publications</h3>
              <hr />
              <ol style={{ fontSize: "small" }}>
                <li>
                  Chandran, M; <b>Bhadada Sk</b>; Ebeling, PR; Gilchrist, NL;
                  Khan, AH; Halbout, P; Lekamwasam, S; Lyubomirsky, G; Mitchell,
                  PJ; Nguyen, TV ; Tiu, KL.IQ driving QI: the Asia Pacific
                  Consortium on Osteoporosis (APCO): an innovative and
                  collaborative initiative to improve osteoporosis care in the
                  Asia Pacific. <b>Osteoporosis International 2020.</b>
                </li>
                <li>
                  Pal, R; Aggarwal, A; Singh, T; Sharma, S ; Khandelwal, N;
                  Garg, A; Bhansali, A; Kumar, A; Yadav, U; Singh, P; Dhiman, V
                  ; Dutta, P ; <b>Bhadada Sk</b>Diagnostic cut-offs, prevalence,
                  and biochemical predictors of sarcopenia in healthy Indian
                  adults: The Sarcopenia-Chandigarh Urban Bone Epidemiological
                  Study (Sarco-CUBES). <b>European Geriatric Medicine 2020.</b>
                </li>
                <li>
                  Kumar N, Kumar A, Uniyal P, Ramalingaiah B, Sharma S, Goni VG,
                  Aggarwal S, <b>Bhadada Sk</b>, Bhushan B. Mimicking high
                  strength lightweight novel structures inspired from the
                  trabecular bone microarchitecture.{" "}
                  <b>
                    Philos Trans A Math Phys Eng Sci. 2020;378(2167):20190448.
                  </b>
                </li>
                <li>
                  Sihota P, Kumar N, Yadav R N, Mehandia V, <b>Bhadada Sk</b>,
                  Dhiman V, Bose J. C, Neradi D, Aggarwal S, Sharma S, Goni V G,
                  Dhaliwal R. Abnormal Bone Structure, Mechanical Properties And
                  Composition Are Associated With Impaired Bone Quality &amp;
                  Quantity In Patients Of T2dm Compare To Non-diabetic
                  Osteoporotic Individuals.{" "}
                  <b>
                    & Quantity In Patients Of T2dm Compare To Non-diabetic
                    Osteoporotic Individuals. Osteoporosis
                    International.2019;30:P S682-S683.
                  </b>
                </li>
                <li>
                  <b>Bhadada Sk</b>, Pal R, Dhiman V, Alonso N, Ralston SH, Kaur
                  S, Gupta R. Adult hypophosphatasia with a novel ALPL mutation:
                  Report of an Indian kindred. <b>Bone Rep. 2020;12:100247.</b>
                </li>
                <li>
                  Das L, Dhiman V, Van Hul W, Bhansali A, Gogate Y, Steenackers
                  E, Mortier G, <b>Bhadada Sk</b>.Spondylo-epi-metaphyseal
                  dysplasia due to a homozygous missense mutation in the gene
                  encoding Matrilin-3 (T120M).<b>Bone Rep. 2020;12:100245</b>
                </li>
                <li>
                  <b>Bhadada Sk</b>, Pal R, Sood A, Dhiman V, Saini UC.
                  Co-administration of Systemic and Intralesional Zoledronic
                  Acid in a Case of Fibrous Dysplasia: A Potentially Novel
                  Therapy. <b>Front Endocrinol (Lausanne). 2019;10:803.</b>
                </li>
                <li>
                  Dadra A, Aggarwal S, Kumar P, Kumar V, Dibar DP,{" "}
                  <b>Bhadada Sk</b>. High prevalence of vitamin D deficiency and
                  osteoporosis in patients with fragility fractures of hip: A
                  pilot study.<b>J Clin Orthop Trauma. 2019;10:1097-1100.</b>
                </li>
                <li>
                  Pal R, Agrawal K, Gupta S, Bhansali A, Behera A,{" "}
                  <b>Bhadada Sk</b>. Worsening of unrecognized tumor-induced
                  osteomalacia with inadvertent use of recombinant human
                  parathyroid hormone. <b>Endokrynol Pol. 2019.</b>
                </li>
                <li>
                  <b>Bhadada Sk</b>, Dhaliwal R, Dhiman V, Rao SD. Fibrogenesis
                  Imperfecta Ossium. <b>Calcif Tissue Int. 2019;104:561-569.</b>
                </li>
                <li>
                  Pal R, <b>Bhadada Sk</b>, Shingare A, Bhansali A, Kamalanathan
                  S, Chadha M, Chauhan P, Sood A, Dhiman V, Sharma DC, Saikia U,
                  Chatterjee D, Agashe V.Tumor-induced osteomalacia: experience
                  from three tertiary care centres In India.{" "}
                  <b>Endocr Connect. 2019 doi: 10.1530/EC-18-0552.</b>{" "}
                </li>
                <li>
                  Kumar N, Sihota P, Yadav R, Dhiman V, Bhadada S,Mehandia V.
                  Investigation of diabetic patient’s fingernail quality to
                  monitor type 2 diabetes induced tissue damage.{" "}
                  <b>Sci Rep. 2019;9: 3193.</b>
                </li>
                <li>
                  Dhaliwal R, Dhiman V, Rao DS, <b>Bhadada Sk</b>. Fibrogenesis
                  Imperfecta Ossium: Clinical Approach to Diagnosis and
                  Management of a Rare Skeletal Disorder.{" "}
                  <b>
                    The Journal of Clinical Endocrinology &amp;
                    Metabolism.2019;104:4005-40015.
                  </b>{" "}
                </li>
                <li>
                  Dhiman V, <b>Bhadada Sk</b>, Dhanwada S, Gopinathan NR.
                  Paradigm change in bone mass: osteopenia to osteopetrosis.{" "}
                  <b>Endocr pract. 2018</b>{" "}
                </li>
                <li>
                  Dhiman V, Aggarwal A, <b>Bhadada SK</b>, Sachdeva N,
                  Gopinathan NR and Dhawan DK. The Imapct of Bisphosphonates on
                  the Osteoclast cells of osteogenesis imperfecta patients;{" "}
                  <b>Biomedical Pharmacology Journal, 2018;11: 645-651.</b>
                </li>
                <li>
                  Rao SD, Qiu S, Dhaliwal R, <b>Bhadada Sk</b>. Letter to the
                  Editor: Severe Rebound-Associated Vertebral Fractures After
                  Denosumab Discontinuation.{" "}
                  <b>J Clin Endocrinol Metab. 2017; 102:2111.</b>{" "}
                </li>
                <li>
                  <b>Bhadada Sk</b>, Dhiman V,Mukherjee S,Aggarwal S, Bal B,
                  Sukumar S,Sood A, Sharma DC,Khandelwal N,Bhansali A,Hul W ,Rao
                  DS. Fibrogenesis Imperfecta Ossium and Response to Human
                  Growth Hormone:{" "}
                  <b>A Potential Novel Therapy .JCEM 2017;102:1750-1756.</b>
                </li>
                <li>
                  <b>Bhadada Sk</b>, Sridhar S, Steenackers E, Dhiman V, Mortier
                  G, Bhansali A, Van Hul W. Camurati-Engelmann Disease
                  (Progressive Diaphyseal Dysplasia):{" "}
                  <b>
                    Reports of an Indian Kindred. Calcif Tissue Int.
                    2013;94:240-7.
                  </b>
                </li>
                <li>
                  <b>Bhadada Sk</b>, Rastogi A, Steenackers E, Boudin E, Arya A,
                  Dhiman V, Van Hul W. Novel SOST gene mutation in a
                  sclerosteosis patient and her parents.{" "}
                  <b>Bone 2012: S8756-3282;1317-8.</b>{" "}
                </li>
                <li>
                  <b>Bhadada Sk</b>, Sridhar S, Muthukrishnan J, Mithal A,
                  Sharma DC, Bhansali A, Dhiman V Predictors of atypical femoral
                  fractures during long term bisphosphonate therapy: a case
                  series &amp; review of literature.
                  <b>Indian J Med Res. 2014;140:46-54.</b>
                </li>
                <li>
                  Chakravarthi SD, Jain K, Kochhar R, <b>Bhadada Sk</b>,
                  Khandelwal N, Bhansali A, Dutta U, Nain CK, Singh K.
                  Prevalence and predictors of abnormal bone mineral metabolism
                  in recently diagnosed adult celiac patients.{" "}
                  <b>Indian J Gastroenterol 2012 ;31:165-70.</b>
                </li>
                <li>
                  Rastogi A, Rattan V, <b>Bhadada Sk</b>. Osteonecrosis of jaw
                  associated with bisphosphonate use{" "}
                  <b>Indian J Endocrinol Metab 2012 ;16:450-2.</b>
                </li>
                <li>
                  <b>Bhadada Sk</b>, Agarwal NK, Singh SK, Agarwal JK.
                  Etiological profile of short stature.{" "}
                  <b>Indian J Pediatr 2003; 70: 545-547.</b>
                </li>
                <li>
                  Sahay RK, Unnikrishnan AG, <b>Bhadada Sk</b>, Reddy V, Singh
                  SK, Agarwal JK. Pictorial CME: Osteogenesis imperfecta.{" "}
                  <b>J Assoc Physicians India 2001; 49: 450</b>
                </li>
                <li>
                  <b>Bhadada S</b>, Sharma DC, Gupta LK, Gupta A, Gupta R.
                  Fibrous dysplasia. <b>J Indian Med Assoc 1998; 96: 100.</b>
                </li>
              </ol>
            </Col>
            <Col sm={4}>
              {/* <hr /> */}
              <br></br>
              <div
                style={{
                  border: "1px solid " + colors.lightGrey,
                  textAlign: "left",
                }}
              >
                <div style={{ margin: 10 }}>
                  <h3>Login</h3>
                  <br />
                  <Form onKeyPress={(e) => e.key === "Enter" && this.login(e)}>
                    <Row form>
                      <Col md={12}>
                        <FormGroup>
                          <Label for="username">User Name</Label>
                          <Input
                            value={this.props.username}
                            onChange={this.onChange}
                            type="text"
                            name="username"
                            id="username"
                            placeholder="user name"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <Label for="password">Password</Label>
                          <Input
                            value={this.props.password}
                            onChange={this.onChange}
                            type="password"
                            name="password"
                            id="password"
                            placeholder="password"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button onClick={this.login}>Login</Button>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
          <div style={{ textAlign: "center" }}>
            <hr style={{background: colors.greenGrey}} />
            <p>
              Department of Endocrinology
              <br />
              Postgraduate Institute of Medical Education &amp; Research
              <br />
              Chandigarh, India - 160012
            </p>
            <p className="lead"></p>
          </div>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    username: state.userForm.username,
    password: state.userForm.password,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (payload) => {
      dispatch(login({ loading: true }));
      axios
        .post(serverUrls.login, payload)
        .then((res) => {
          dispatch(loginSuccess({ loading: false }));
          redirectTo(clientUrls.home);
        })
        .catch((err) => {
          dispatch(loginFailure({ loading: false, errors: err.response.data }));
        });
    },
    formInputChange: (payload) => {
      dispatch(formInputChange(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
